
<div class="scroll">
    <div *ngFor="let n of matches" class="container">
        <div>
            {{ n.Score }}
        </div>
        <div>
            <div *ngFor="let x of n.Name">
                {{ x }}
            </div>
        </div>
        <div class="links">
            <div *ngFor="let x of n.links">
                <a href="{{x.LinkText}}" target="_blank">{{ x.Type }}</a>
            </div>
        </div>
    </div>
</div>


